var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100CameraRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F14646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.973 8.32556L17.0366 6.26123L17.8856 7.11044L7.26078 17.7387L6.41185 16.8895L6.92204 16.3791L6.73922 16.2606C6.54689 16.1358 6.38873 15.9651 6.27907 15.7637C6.16944 15.5624 6.11175 15.3369 6.11124 15.1077V8.89205C6.11124 8.52668 6.25634 8.17628 6.5146 7.91794C6.77286 7.65959 7.12313 7.51446 7.48836 7.51446H13.702C13.9311 7.51497 14.1565 7.57267 14.3577 7.68233C14.559 7.79202 14.7297 7.95024 14.8544 8.14263L14.973 8.32556ZM7.31202 8.71569V15.2842H8.01657L13.8785 9.42041V8.71569H7.31202ZM11.5348 15.2842H13.0036V13.815L17.3112 9.50592V14.7964L14.2043 12.9316V15.1079C14.2043 15.4733 14.0592 15.8237 13.801 16.082C13.5427 16.3403 13.1925 16.4855 12.8272 16.4855H10.334L11.5348 15.2842Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100CameraRed);
export default __webpack_public_path__ + "static/media/100-camera-red.6e4bd2caf3e15f760838150a6cc30172.svg";
export { ForwardRef as ReactComponent };